module.exports = __webpack_public_path__ + "static/media/tapir-blue.1b7a128c.png";